@file:OptIn(ExperimentalTime::class, ExperimentalUuidApi::class)

package dev.moetz.sslcertificatetool.model

import dev.moetz.sslcertificatetool.serializer.UuidAsStringSerializer
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime
import kotlin.time.Instant
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class CertificateInformation(
    @Serializable(with = UuidAsStringSerializer::class)
    val id: Uuid,
    val domain: String,
    val checkedAt: Instant,
    val opensslInformation: OpensslInformation,
    val certificates: List<Certificate>,
    val scts: List<SCT>,
) {

    @Serializable
    data class OpensslInformation(
        val fullOutput: String,
        val certificates: List<String>,
    )

    @Serializable
    data class Certificate(
        val issuer: String,
        val subject: String,
        val notAfter: Instant,
        val notBefore: Instant,
        val issuerAlternatives: List<String>,
        val subjectAlternatives: List<String>,
    )

    @Serializable
    data class SCT(
        val version: String,
        val logId: String,
        val timestamp: String,
        val extension: String?,
        val signature: String,
        val logList: LogList?,
    ) {
        @Serializable
        data class LogList(
            val operatorName: String,
            val description: String,
            val logId: String,
            val url: String,
            val intervalStart: Instant,
            val intervalEnd: Instant,
            val isTiled: Boolean,
        ) {
            val nameAndOperator: String get() = "$description ($operatorName)"
        }
    }

}
